module.exports = __webpack_public_path__ + "static/media/profile.5a0ca145.png";